import { toast } from "react-toastify";

let overlay = null;

const addOverlay = () => {
  if (overlay) return;

  overlay = document.createElement("div");
  overlay.className = "confirm-overlay";

  document.body.appendChild(overlay);
};


const removeOverlay = () => {
  if (!overlay) return;

  overlay.remove();
  overlay = null;
};


export const confirmToast = ({
  message,
  onConfirm,
  onCancel,
  confirmText = "Conferma",
  cancelText = "Annulla",
}) => {
  const toastId = "confirm-toast-global";

  if (toast.isActive(toastId)) return;

  addOverlay();

  toast(
    ({ closeToast }) => (
      <div>
        <p>{message}</p>

        <div style={{ display: "flex", gap: "8px", marginTop: "12px" }}>
          <button
            onClick={async () => {
              await onConfirm?.();
              closeToast();
            }}
          >
            {confirmText}
          </button>

          <button
            onClick={() => {
              onCancel?.();
              closeToast();
            }}
          >
            {cancelText}
          </button>
        </div>
      </div>
    ),
    {
      toastId,
      autoClose: false,
      closeOnClick: false,
      className: "confirm-toast",

      onClose: () => {
        removeOverlay();
      },
    }
  );

};
